module["exports"] = ["کرولا", "اکورڈ", "سوک"];
